import {
  TagIcon as Target,
  Cog6ToothIcon as Settings,
  CalendarDaysIcon as Calendar,
  ChartBarIcon as BarChart3,
  QuestionMarkCircleIcon as HelpCircle,
  UserGroupIcon as UserGroup,
  PlayIcon,
  ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline'
import { SidebarSection, SidebarNavigationItem } from '../../../shared/types/navigation'
import { resolveBackOfficeDashboardUrl } from '../../../shared/utils/sidebarNavigation'

/**
 * Navigation items for the facilitator sidebar
 * These are the exact items provided by the user for the facilitator component
 */
export const FACILITATOR_NAVIGATION_ITEMS: SidebarNavigationItem[] = [
  {
    id: SidebarSection.DASHBOARD_FACILITATOR,
    label: 'facilitator.navigation.dashboard',
    icon: Target
  },
  {
    id: SidebarSection.TRAINING_SPRINT_MANAGEMENT,
    label: 'facilitator.navigation.manageTrainingSprints',
    icon: Settings
  },
  {
    id: SidebarSection.SESSIONS,
    label: 'facilitator.navigation.upcomingActivities',
    icon: Calendar,
    disabled: false // Now functional
  },
  {
    id: SidebarSection.DOWNLOAD_REPORTS,
    label: 'facilitator.navigation.manageReports',
    icon: BarChart3,
    disabled: false // Now functional with new components
  },
  {
    id: SidebarSection.REFLECTIONS,
    label: 'facilitator.navigation.reflections',
    icon: ChatBubbleLeftRightIcon
  },
  {
    id: SidebarSection.GAME_CENTER_FACILITATOR,
    label: 'facilitator.navigation.gameCenter',
    icon: PlayIcon,
    hideInSidebar: true
  },
  {
    id: SidebarSection.USERS,
    label: 'admin.navigation.backOffice',
    icon: UserGroup,
    adminOnly: true,
    externalUrl: resolveBackOfficeDashboardUrl()
  }
]

/** FAQ — appended last in FacilitatorDashboard navigation assembly */
export const FACILITATOR_FAQ_NAV_ITEM: SidebarNavigationItem = {
  id: SidebarSection.QA,
  label: 'facilitator.navigation.faqGuides',
  icon: HelpCircle
}
